module.exports = __webpack_public_path__ + "img/station_expanded_pin.416ecb75.png";